import { render, staticRenderFns } from "./AddRouteCity.vue?vue&type=template&id=5b11c24d&"
import script from "./AddRouteCity.vue?vue&type=script&lang=ts&"
export * from "./AddRouteCity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports